<template>
    <div v-if="isModalVisible">
        <transition name="slide">
            <div id="groupModal122" class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg" style="max-width: 100%;">
                    <div class="modal-content p-2">
                        <div class="modal-header manage_header">
                          <div class="" style="width: 100%;">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>

                        </div>
                        <div class="modal-body user-info" v-if="(userInfo.email && loading == false)">
                          <div class="row mb-4">
                            <div class="">
                                <h5 class="modal-title">{{ userInfo.first_name + ' ' + userInfo.last_name }}</h5>
                                <h6 class="uemail">{{ userInfo.email }}</h6>
                                <h6 class="accountname">{{ userInfo.current_location_name }}</h6>
                            </div>
                          </div>                         
                          <div v-if="locationCount > 0">   
                            <div v-if="updateMsg" class="text-green">{{ updateMsg }}</div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <label class="form-label">What do you like to do</label>
																		<div class="col-4 p-0">
																			<div class="row">
																				<div class="col">
																					<div class="chkboxwrapper">
																						<div class="custom-control custom-radio">
																						<input 
																								type="radio" 
																								name="add_user"
																								:id="'add_user_1'"
																								value="add"
																								v-model="transfer_type"
																								class="custom-control-input"
																								v-validate="'required'">
																						<label class="custom-control-label" :for="'add_user_1'">Add</label>
																						</div>
																					</div>
																				</div>
																				<div class="col">
																					<div class="chkboxwrapper">
																						<div class="custom-control custom-radio">
																						<input 
																								type="radio" 
																								name="transfer_user"
																								:id="'transfer_user_1'"
																								value="transfer"
																								v-model="transfer_type"
																								class="custom-control-input"
																								v-validate="'required'">
																						<label class="custom-control-label" :for="'transfer_user_1'">Transfer</label>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
                                    <div v-if="verrors.firstByRule('transfer_user', 'required')" class="margin-bottom-5 validate-warning-msg">Add or Transfer is required</div>
                                </div>
                            </div>
                            <div class="row mt-2">
															<div class="col-12">
																<div class="col-12 p-0">
																		<label class="form-label">Select the role for the account: </label>
																</div>
																<div class="col-4 p-0">
																	<div class="row">
																		<div class="col">
																			<div class="chkboxwrapper">
																				<div class="custom-control custom-radio">
																					<input 
																						name="newaccount_role"
																						value="Manager"                       
																						type="radio" 
																						v-model="newaccount_role"
																						v-validate="'required'"
																						class="custom-control-input"
																						:id="'newaccount_role_manager'"
																						>
																					<label class="custom-control-label" :for="'newaccount_role_manager'">Manager</label>
																				</div>
																			</div>
																		</div>
																		<div class="col">
																			<div class="chkboxwrapper">
																				<div class="custom-control custom-radio">
																					<input 
																						name="newaccount_role"
																						value="Mentor"                       
																						type="radio" 
																						v-model="newaccount_role"
																						v-validate="'required'"
																						class="custom-control-input" 
																						:id="'newaccount_role_mentor'"
																						>
																					<label class="custom-control-label" :for="'newaccount_role_mentor'">Mentor</label>
																				</div>
																			</div>
																		</div>
																		<div class="col">
																			<div class="chkboxwrapper">
																				<div class="custom-control custom-radio">
																					<input 
																						name="newaccount_role"
																						value="Mentee"                       
																						type="radio" 
																						v-model="newaccount_role"
																						v-validate="'required'"
																						class="custom-control-input"
																						:id="'newaccount_role_mentee'"
																						>
																					<label class="custom-control-label" :for="'newaccount_role_mentee'">Mentee</label>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div v-if="verrors.firstByRule('newaccount_role', 'required')" class="margin-bottom-5 validate-warning-msg">Select Role is required</div>
															</div>
														</div>
                            <div class="row mt-2">
                                <div class="col-8">
                                    <label class="form-label">Choose an Account </label>
                                </div>
                                <div class="col-4">
                                    <input
                                        type="text"
                                        name="org name"
                                        id="org_name"
                                        class="search_org_text"
                                        ref="org_name"
                                        v-model="org_name"
                                        maxlength="250"
                                        @keyup.enter="setLocationFilterbyName">
                                        <span class="search-icon" @click="setLocationFilterbyName">
                                        <i class="fa fa-search search_icons"></i>
                                    </span>
                                </div>
                                <div class="row edit_row">
                                    <div class="col-12">
                                        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                        <div v-if="locationCount > 0" class="row_item_readonly">
                                            <div class="row_data_border" v-for="(item, aindex) in locations" :key="aindex">
                                                <div class="location_item_2">
																								<div class="chkboxwrapper">
																									<div class="custom-control custom-radio">
                                                    <input 
                                                        type="radio" 
                                                        name="account_id"
                                                        :id="'account_id_' + aindex"
                                                        :value="item.accId"
                                                        v-model="account_selected" 
																												class="custom-control-input" 
                                                        v-validate="'required'">
																										<label class="custom-control-label" :for="'account_id_' + aindex">{{ item.accountName }}</label>		
																										</div>
																									</div>
                                                </div>
                                                <div class="location_item_3">{{ (item.city) ? item.city : "&nbsp;" }}</div>
                                                <div class="location_item_4">{{ (item.stateCode) ? item.stateCode : "&nbsp;" }}</div>
                                                <div class="clearfix"></div>
                                            </div>
                                            <div v-if="verrors.firstByRule('account_id', 'required')" class="margin-bottom-5 validate-warning-msg">Account is required</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row submit_row justify-content-md-center">
                                <div class="col-6">
                                    <button type="button" @click.prevent="onSubmit" class="btn btn-sm btn-blue saveBtn text-center">Save</button>
                                </div>
                            </div>
                            </div>
                        </div>

                        <div class="text-red text-center m-4">{{ getNoRecordText(locationCount) }}</div>
										<TransferConfirmModal 
												:isModalVisible="isTransferConfirmModalVisible" 
												@close="isTransferConfirmModalVisible = false"
												ref="confirmation_resources_modal">
											<span v-if="loading" class="pull-right text-danger">
												Loading...
											</span>
											<div slot="header" class="confirm_message">
												Are you sure you want to {{ transfer_type }} the primary admin to this account?
											</div>
											<div slot="body">

											</div>
											<div slot="footer" class="col-12 override-padding">
												<button type="button" class="btn btn-sm cancelBtn float-left" @click="closeConfirmationAction">Cancel</button>
												<button class="btn btn-sm confirmBtn float-right" @click="saveUser">Confirm</button>
											</div>
										</TransferConfirmModal>

                    </div>
                </div>
            </div>
        </transition>


    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import TransferConfirmModal from './resources_confirm_modal.vue';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible', 'accountId', 'accountName'],
    data() {
        return {
            loading: false,
            user_id: '',
            userInfo: {},
            transfer_type: '',
            locations: [],
            updateMsg: '',
            account_selected: '',
            isTransferConfirmModalVisible: '',
            org_name: '',
            main_locations: [],
            locationCount: 0,
            activeAccountCount: 0,
						mentor_only: 0,
						newaccount_role: '',
						existingaccount_role: '',
        }
    },
    components: {
        TransferConfirmModal
    },
    methods: {
        hide() {
            this.close();
        },
        close() {
            this.org_name = '';
            this.transfer_type = '';
            this.account_selected = '';
            this.verrors.clear();
            this.$emit('close');
        },
        fetchLocationsListitems(userId) {
            this.user_id = userId;
            this.loading = true;
            this.locations = [];
            axios('/enterprise-admn/getUserNotExistsInLocations/' + this.user_id + '/' + this.accountId,
            {
                method: 'GET',
            })
            .then(response => {
                this.updateMsg = '';
                this.loading = false;
                this.locations = response.data.data;
                this.locationCount = response.data.data.length;
                this.userInfo = response.data.userInfo;
                this.main_locations = response.data.data;
								this.newaccount_role = this.userInfo.oldAccountRole;
								this.existingaccount_role = this.userInfo.oldAccountRole;
                this.activeAccountCount = response.data.userInfo.activeAccountCount;
            })
            .catch(() => {
            });
          setTimeout(() => {
            let element = document.getElementById('groupModal122');    
            element.scrollIntoView(true);
          }, 2000);

        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.user_id) {
                    return 'No Location Found';
                }
            }
        },
        closeConfirmationAction() {
            this.isTransferConfirmModalVisible = false;
            //this.close();
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    if (this.userInfo.is_primaryadmin) {
											if (this.transfer_type == 'transfer') {
												alert("Primary Admin can't be transferred into another account");
											} else {
												setTimeout(() => {
													let element = document.getElementById('groupModal122');    
													element.scrollIntoView(true);
													this.isTransferConfirmModalVisible = true;
												}, 1000);
											}
                    } else {
											this.saveUser();   
                    }
                } 
            });
        },
        saveUser() {
            this.loading = true;
            axios('/enterprise-admn/addTransferUser',
            {
                method: 'POST',
                data: {
                    user_id: this.user_id,
                    transfer_type: this.transfer_type,
                    account_selected: this.account_selected,
										currentLocationId: this.accountId,
										newaccountRole: this.newaccount_role,
										existingAccountRole: this.existingaccount_role,
                }
            })
            .then(response => {
							if (this.transfer_type == 'add') {
									this.updateMsg = 'User added successfully';
							} else {
									this.updateMsg = 'User transferred successfully';
							}
							this.loading = false;
							this.closeConfirmationAction();
							this.$emit('close', this.updateMsg);
            })
            .catch(() => {
            });
        },
        setLocationFilterbyName() {
            if (this.org_name) {
                this.locations = this.main_locations.filter(account => account.accountName.toLowerCase().includes(this.org_name.toLowerCase()));
            } else {
                this.locations = this.main_locations;
            }
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 99998;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.radiobox label, .radiobox input { margin-right: 10px; }
.form-label { font-size: 13px; font-weight: 900; } 
.submit_row { margin: 4rem; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}
.success-msg { font-size:  1.5rem; font-weight: 900;}
.success-note i { font-size: 1.25rem; margin-right: 10px; }
.gotoBtn { margin-top: 16rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.location_item_1 { width: 5%; float: left; }
.location_item_2 { width: 65%; float: left; }
.location_item_3 { width: 15%; float: left; }
.location_item_4 { width: 15%; float: left; }
.row_item_readonly { width: 100%; }
.row_data_border { padding: 5px 0 0 0; margin-bottom: 0px; font-size: 14px;}
.row_data_border:nth-last-child(1) { border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.edit_row { width: 100%; margin-left: 0px; }
.linked_group_account_1 { width: 100%; float: left; }
.text-blue { text-align: center; color: #00acee !important; font-weight: 900; font-style: italic; }
.loading_show { height: auto; }
.text-green { color: #28a745 !important; font-weight: 900; }
.cancelBtn, .cancelBtn:focus, .cancelBtn:active, .cancelBtn:hover {
  color: #00acee !important; 
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 100px;
  border-radius: 10px;
}
.confirmBtn, .confirmBtn:focus, .confirmBtn:active, .confirmBtn:hover {
  color: #FFF !important;
  background: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  width: 100px;
}
.manage_header { padding: 0 1rem; }
.mheading_1 { width: 5%; }
.mheading_2 { width: 90%; }
.mheading_4 { width: 5%; }
.uemail { font-size: 12px; font-style: italic; margin: 2px 0; }
.accountname { font-size: 13px; font-weight: 900; margin: 4px 0 10px 0; }
.user-info { padding: 0.5rem 1.5rem !important; }
.search-icon {
	border: 1px solid #000;
	padding: 4px 5px 4px 0px;
	border-left: 0;
	border-radius: 10px;
	border-top-left-radius:0;
	border-bottom-left-radius:0;
}
.search_icons { font-size: 20px; color: #bfbfbf; cursor: pointer; border-width: 1px; border-color: #000;  }
.search_org_text { margin-right: -5px;  
	border-radius: 10px;
		padding: 4px 0px 4px 5px;
		border-top-right-radius:0;
		border-bottom-right-radius:0;
		border: 1px solid #000;
		border-right: 0;

	 width: 120px;outline: 0;  background-color: #FFF;  }
.text-error { color: #FF0000; }
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}
.custom-radio .custom-control-label::before {
	width: 15px;
	height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_transfer_modal.vue